<template>
  <div id="mySidenav" class="sidenav" :style="{left:this.$store.state.photo.opennav.mySidenav}">
    <div class="px-2 photo_filter_sidebar" id="sidebar">
      <!-- FILTER -->
      <div class="filter-head mb-3">
        <span class="filter-txt">
          {{ $t("filter") }}
        </span>
        <button type="button" class="btn btn-light float-right" style="border: 0px!important;" @click="resetFilters">zurücksetzen </button>
      </div>

      <hr class="solid">

      <!-- SCHLAGWORTE -->
      <div>

        <div class="filter-head mt-2 mb-2">
          <span role="button" data-toggle="collapse" class="font-bold font-s1">
            Schlagworte
          </span>
        </div>

        <div id="accordion" class="accordion-style mt-2 filter_style ml-1 ">

          <div class="mb-3 " v-for="taggroup in taggroups">
            <div class="" :id="'collapse-left-heading-'+ taggroup.projectparamid">
              <h5 class="mb-0 pos-rel">

                <div role="button" data-toggle="collapse" class="filterkeywords font-s2" :href="'#collapse-left-'+taggroup.projectparamid"
                     aria-expanded="false" aria-controls="collapse-left">
                  <a><i class="fa fa-chevron-down"></i> {{taggroup.group}}</a>
                </div>

                <div class="switch switch-text">
                  <label>
                    <input type="checkbox" v-model="selectedTags" :value=taggroup.group>
                    <span class="lever float-right mr-0">
                    <span class="onoffswitch-inner"></span>
                  </span>
                  </label>
                </div>
              </h5>
            </div>
            <div :id="'collapse-left-'+taggroup.projectparamid" class="collapse hide cscroll" data-parent="#accordion" aria-labelledby="collapse-left-heading-1"   style="max-height: 200px;overflow-y: auto;overflow-x: hidden; margin-left: 10px;">
              <div class="custom-control custom-checkbox " v-for="tag in tags" v-if="tag.group == taggroup.group">
                <template v-if="tag.type=='1'">
                  <input type="text"
                         v-on:blur="tagsCheckbox2(tag,$event)"
                         class="form-control-sm sm-input enterblur"
                         :value="getTagSearchValue(tag)"
                         :id="'tag_'+tag.projectparamid"
                         :name="'n_'+tag.projectparamid" >
                  <label class="font-s3" v-bind:for="'tag_'+tag.projectparamid">{{tag.name}}</label>
                </template>
                <template v-if="tag.type=='0'">
                  <!--                         -->
                  <input type="checkbox"
                         class="custom-control-input"
                         :value="tag"
                         v-model="selectionstags"
                         :id="'tag_'+tag.projectparamid"
                         :name="'n_'+tag.projectparamid" >
                  <label class="custom-control-label side_label" v-bind:for="'tag_'+tag.projectparamid">{{tag.name}}</label>
                </template>
              </div>
            </div>
          </div>

        </div>

      </div>

      <hr class="solid">

      <!-- SWITCHES -->
      <div>
        <label class="font-bold font-s1">Foto mit</label>

        <div class="switch-candy switch-3">
          <label class="label font-s2 filter-fm">Verortung</label>
          <div class="switch-toggle switch-3 switch-candy">

            <input id="v1_a" type="radio" value="1" v-model="hasplans" />
            <label for="v1_a" class="state-on" onclick="">ja</label>

            <input id="v1_b" type="radio" value="2" v-model="hasplans" />
            <label for="v1_b" class="state-dis disabled" checked="checked" onclick="">alle</label>

            <input id="v1_c" type="radio" value="0" v-model="hasplans" />
            <label for="v1_c" class="state-off" onclick="">nein</label>

          </div>
        </div>

        <div class="switch-candy switch-3">
          <label class="label font-s2 filter-fm">Schlagwort</label>
          <div class="switch-toggle switch-3 switch-candy">

            <input id="v2_a" type="radio" value="1" v-model="hastags" />
            <label for="v2_a" class="state-on" onclick="">ja</label>

            <input id="v2_b" type="radio" value="2" v-model="hastags" />
            <label for="v2_b" class="state-dis disabled" checked="checked" onclick="">alle</label>

            <input id="v2_c" type="radio" value="0" v-model="hastags" />
            <label for="v2_c" class="state-off" onclick="">nein</label>

          </div>
        </div>
        <div class="switch-candy switch-3">
          <label class="label font-s2 filter-fm">Beschreibung</label>
          <div class="switch-toggle switch-3 switch-candy">

            <input id="v3_a" type="radio" value="1" v-model="hasdescription" />
            <label for="v3_a" class="state-on" onclick="">ja</label>

            <input id="v3_b" type="radio" value="2" v-model="hasdescription" />
            <label for="v3_b" class="state-dis disabled" checked="checked" onclick="">alle</label>

            <input id="v3_c" type="radio" value="0" v-model="hasdescription" />
            <label for="v3_c" class="state-off" onclick="">nein</label>

          </div>
        </div>

        <div class="switch-candy switch-3">
          <label class="label font-s2 filter-fm">Memo</label>
          <div class="switch-toggle switch-3 switch-candy">

            <input id="v4_a" type="radio" value="1" v-model="hasmemos" />
            <label for="v4_a" class="state-on" onclick="">ja</label>

            <input id="v4_b" type="radio" value="2" v-model="hasmemos" />
            <label for="v4_b" class="state-dis disabled" checked="checked" onclick="">alle</label>

            <input id="v4_c" type="radio" value="0" v-model="hasmemos" />
            <label for="v4_c" class="state-off" onclick="">nein</label>

          </div>
        </div>


<!--        <div class="switch"  >-->
<!--          <label class="w-100 font-s2">  Foto mit Verortung-->
<!--            <input type="checkbox"-->
<!--                   id="1"-->
<!--                   v-model="hasplans"-->
<!--                   value="1">-->
<!--            <span class="lever float-right mr-0"></span>-->
<!--          </label>-->
<!--        </div>-->
<!--        <div class="switch">-->
<!--          <label class="w-100 font-s2">  Foto mit Schlagwort-->
<!--            <input type="checkbox"-->
<!--                   id="2"-->
<!--                   v-model="hastags"-->
<!--                   value="1">-->
<!--            <span class="lever float-right mr-0"></span>-->
<!--          </label>-->
<!--        </div>-->
<!--        <div class="switch"  >-->
<!--          <label class="w-100 font-s2">  Foto mit Beschreibung-->
<!--            <input type="checkbox"-->
<!--                   id="3"-->
<!--                   v-model="hasdescription"-->
<!--                   value="1"-->
<!--            >-->
<!--            <span class="lever float-right mr-0"></span>-->
<!--          </label>-->
<!--        </div>-->

      </div>

      <hr class="solid">

      <div id="accordion_2" class="accordion-style mt-2 filter_style ml-1">
        <div class="mb-3 mt-4" style="margin-left:-0.25rem">
          <div class="" id="collapse-left-heading-eresteller">
            <h5 class="mb-0 pos-rel">
              <a role="button" data-toggle="collapse" href="#collapse-left-eresteller" aria-expanded="false" aria-controls="collapse-left-eresteller">
                Ersteller
              </a>
              <div class="switch switch-text d-none">
                <label>
                  <input type="checkbox" v-model="selectedTags" value="ersteller">
                  <span class="lever float-right mr-0">
                    <span class="onoffswitch-inner"></span>
                  </span>

                </label>
              </div>
            </h5>
          </div>
          <div id="collapse-left-eresteller" class="collapse hide cscroll" data-parent="#accordion_2" aria-labelledby="collapse-left-heading-eresteller"   style="max-height: 200px;overflow-y: auto;overflow-x: hidden; margin-left: 5px;">

            <div class="custom-control custom-checkbox " v-for="creator in creators">
              <input type="checkbox"
                     v-on:click="tagsCheckbox3(creator,$event)"
                     class="custom-control-input"
                     v-bind:value="creator.pduserid"
                     v-model="Creaters"
                     :id="'pduser_'+creator.pduserid"
                     :name="creator.pduserid">
              <label class="custom-control-label custom-label" v-bind:for="'pduser_'+creator.pduserid" >{{creator.firstname}} {{creator.lastname}} ({{creator.email}})</label>
            </div>

          </div>
        </div>

      </div>

<!--      <div id="accordion_3" class="accordion-style mt-2 filter_style ml-1">-->
<!--        <div class="mb-3" style="display:none;">-->
<!--          <div class="" id="collapse-left-heading-plane1">-->
<!--            <h5 class="mb-0 pos-rel">-->
<!--              <a role="button" data-toggle="collapse" href="#collapse-left-Fotosa" aria-expanded="false" aria-controls="collapse-left-plane">-->
<!--                Fotosammlungen-->
<!--              </a>-->
<!--              <div class="switch switch-text">-->
<!--                <label>-->
<!--                  <input v-model="selectedTags"  value="fotosammlungen" type="checkbox">-->
<!--                  <span class="lever float-right mr-0">-->
<!--                    <span class="onoffswitch-inner"></span>-->
<!--                  </span>-->
<!--                </label>-->
<!--              </div>-->
<!--            </h5>-->
<!--          </div>-->
<!--          <div id="collapse-left-Fotosa" class="collapse hide cscroll" data-parent="#accordion_3" aria-labelledby="collapse-left-heading-1"   style="max-height: 200px;overflow-y: auto;overflow-x: hidden;">-->

<!--            <div class="custom-control custom-checkbox " v-for="selection in selections" :key="selection.id" v-if="selection.title">-->
<!--              <input type="checkbox" class="custom-control-input" v-on:click="tagsCheckbox(selection,$event)" v-bind:value="selection.id" :id="'ss_'+selection.id" :name="'ss_'+selection.id">-->
<!--              <label class="custom-control-label custom-label" v-bind:for="'ss_'+selection.id">-->
<!--                {{selection.title}}-->
<!--              </label>-->
<!--            </div>-->

<!--          </div>-->
<!--        </div>-->


<!--      </div>-->

      <hr class="solid">


      <div id="accordion_4" class="accordion-style mt-2 filter_style ml-1">
        <div class="mb-3 mt-4" style="margin-left:-0.25rem">
          <div class="" id="collapse-left-heading-plane">
            <h5 class="mb-0 pos-rel">
              <a role="button" data-toggle="collapse" href="#collapse-left-plane" aria-expanded="false" aria-controls="collapse-left-plane">
                Pläne
              </a>
              <div class="switch switch-text d-none">
                <label>
                  <input type="checkbox" v-model="selectedTags" value="plane">
                  <span class="lever float-right mr-0">
                    <span class="onoffswitch-inner"></span>
                  </span>
                </label>
              </div>

            </h5>
          </div>
          <div id="collapse-left-plane" class="collapse hide cscroll" data-parent="#accordion_4" aria-labelledby="collapse-left-heading-1"  style="max-height: 200px;overflow-y: auto;overflow-x: hidden;">

            <div class="custom-control custom-checkbox " v-for="(plan, key, index) in plans" :key="key">
<!--              v-model="isPlanChecked(plans[key].value)"-->
              <input type="checkbox"
                     v-on:click="tagsCheckbox4(plan,$event)"
                     class="custom-control-input"
                     v-bind:value="plan.pdplanid"
                     v-model="plansKeys"
                     :id="'plan_'+plan.pdplanid"
                     :name="'plan_'+plan.pdplanid">
              <label class="custom-control-label custom-label" v-bind:for="'plan_'+plan.pdplanid" >{{plan.description}}</label>
            </div>
          </div>
        </div>


      </div>

      <hr class="solid">

      <div id="accordion_5" class="accordion-style mt-2 filter_style ml-1">
        <div class="mb-3 mt-4" style="margin-left:-0.25rem">
          <div class="" id="collapse-left-heading-photodays">
            <h5 class="mb-0 pos-rel">
              <a role="button" data-toggle="collapse" href="#collapse-left-photodays" aria-expanded="false" aria-controls="collapse-left-photodays">
                Aufnahmetag
              </a>
              <div class="switch switch-text d-none">
                <label>
                  <input type="checkbox" v-model="selectedTags" value="photodays">
                  <span class="lever float-right mr-0">
                    <span class="onoffswitch-inner"></span>
                  </span>
                </label>
              </div>

            </h5>
          </div>

          <div id="collapse-left-photodays" class="collapse hide cscroll" data-parent="#accordion_5" aria-labelledby="collapse-left-heading-1" style="max-height: 200px;overflow-y: auto;overflow-x: hidden;">

            <div class="custom-control custom-checkbox " v-for="(photoday, key, index) in photodays" :key="key" style="">
              <!--              v-model="isPlanChecked(plans[key].value)"-->
              <input type="checkbox"
                     v-on:click="tagsCheckbox5(photoday,$event)"
                     class="custom-control-input"
                     v-bind:value="photoday.date"
                     v-model="photodayKeys"
                     :id="'photoday_'+photoday.date"
                     :name="'photoday_'+photoday.date">
              <label class="custom-control-label custom-label" v-bind:for="'photoday_'+photoday.date" >{{photoday.formateddate}}</label>
            </div>
          </div>
        </div>

      </div>

      <hr class="solid">

      <!-- SONSTIGES -->
        <div id="accordion_6" class="accordion-style mt-2 filter_style ml-1">
          <div class="mb-3 mt-4" style="margin-left:-0.25rem">
            <div class="" id="collapse-left-heading-search">
              <h5 class="mb-0 pos-rel">
                <a role="button" data-toggle="collapse" href="#collapse-left-search" aria-expanded="false" aria-controls="collapse-left-search">
                 Sonstiges
                </a>
              </h5>
            </div>

            <div id="collapse-left-search" class="collapse hide cscroll" data-parent="#accordion_6" aria-labelledby="collapse-left-heading-1" style="max-height: 200px;overflow-y: auto;overflow-x: hidden;">
              <div class="input-group mb-3 pl-0 col-12">
                <input v-model="searchStringByRunid" class="form-control input-style font-s2" placeholder="Foto-Nr" data-on-color="success" type="text" name="namerunid" required>
              </div>
              <div class="input-group mb-3 pl-0 col-12">
                <input v-model="searchStringByName" class="form-control input-style font-s2" placeholder="Beschreibung, Dateiname" data-on-color="success" type="text" name="name" required>
              </div>
            </div>
          </div>
        </div>

      <hr class="solid">

      <!-- SORTIERUNG -->
      <div id="accordion_7" class="accordion-style mt-2 filter_style ml-1">
        <div class="mb-3 mt-4" style="margin-left:-0.25rem">
          <div class="" id="collapse-left-heading-sort">
            <h5 class="mb-0 pos-rel">
              <a role="button" data-toggle="collapse" href="#collapse-left-sort" aria-expanded="false" aria-controls="collapse-left-sort">
                Sortierung
              </a>
            </h5>
          </div>


<!--            <div class="input-group mb-3 pl-0 col-12">-->
<!--          <label for="orderlisting" class="w-100 font-s1 font-bold">Sortierung</label>-->


          <div id="collapse-left-sort" class="collapse hide cscroll" data-parent="#accordion_7" aria-labelledby="collapse-left-heading-1" style="max-height: 200px;overflow-y: auto;overflow-x: hidden;">
            <div class="input-group mb-3 pl-0 col-12">

              <select
                class="w-100 form-control font-s2" style="height: 26px; padding-top: 0px;padding-bottom: 0px;"
                v-model:name="orderflag"
                id="orderlisting">
                <option v-for="order in listorder" :value="order.orderkey">{{ order.title }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>














    </div>
  </div>
</template>

<script>
import axios from '../../../utils/axiosinstance'
// import axios from 'axios'
import moment from 'moment'
import {mapState} from 'vuex'
import Vue from 'vue'



export default {
  name: 'SideNav',
  props: ['searchString','photosUpdate'],
  data () {
    return {
      searchStringByName: '',
      projectId: null,
      searchStringByRunid: '',
      creators: [],
      plans: [],
      photodays: [],
      selectedTags: [],
      selections: [],
      selectionstemp: [],
      selectionstags: [],
      selectionskeys: [],
      tagselectionskeys: [],
      tagCreaterKeys: [],
      plansKeys: [],
      photodayKeys: [],
      Creaters: [],
      tags: [],
      startDate: '',
      endDate: '',
      photos: [],
      projectID: '',
      fotosammlungen: '',
      getFiltersUrl: process.env.VUE_APP_BASE_URL + 'project/' + this.$route.params.id + '/photos/getfilterparams',
      getImagesUrl: process.env.VUE_APP_BASE_URL + 'project/' + this.$route.params.id + '/photos/getlist1',
      'hasplans': '2',
      'hastags': '2',
      'hasdescription': '2',
      'hasmemos': '2',
      taggroups: [],
      listorder: [
        {
          title: 'Datum ↑',
          orderkey: 'photodate ASC'
        },
        {
          title: 'Datum ↓',
          orderkey: 'photodate DESC'
        },
        {
          title: 'Nummer ↑',
          orderkey: 'runid ASC'
        },
        {
          title: 'Nummer ↓',
          orderkey: 'runid DESC'
        },
      ],
      orderflag: 'photodate DESC',
      itemsperpage: 40,
      callCounter: 0
    }
  },

  mounted () {
    this.getImagesOnModalOpen();

    // console.log('RUN 1')
    this.getFilters()
    // console.log('RUN 2')
    this.getProject()
    // console.log('RUN 3')
    this.getPlans()
    this.getPhotodays()
    // console.log('RUN 4')
    this.getUsers()

    this.$root.$on('afterDateChange', data => {
      this.getImages('afterDateChange')
    })

    this.$root.$on('pageChangeHandler', () => {
      const elements = document.querySelectorAll('.screen-height.photos-docu');
      if (elements){
        elements.forEach(element => {
          const styles = getComputedStyle(element);
          if (styles.display != 'none'){
            element.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        })
      }
      this.getImages('pageChangeHandler');
    });
  },
  beforeDestroy () {
    this.$root.$off('pageChangeHandler')
    this.$root.$off('afterDateChange')
  },
  computed: {
    ...mapState({
      images : state => state.photo.photos,
      refresh_photos_list : state => state.photo.refreshlist,
      rectangle: state => state.photo.rectangle
    }),
  },

  created () {
    // console.log('CALL CREATED', typeof(this.$store.state.photo.endDate)  != 'object')
  },
  methods: {
    getImagesOnModalOpen(){
      let _this = this
      $('#tasks-photos_Modal').one('show.bs.modal', function(){
         if (_this.images.length < 1 && _this.projectId == _this.$route.params.id){
           _this.getImages('created');
         }
      })
      $('#photos_Modal').one('show.bs.modal', function(){
         if (_this.images.length < 1 && _this.projectId == _this.$route.params.id){
           _this.getImages('created');
         }
      })
      _this.projectId = _this.$route.params.id
    },

    closeNav () {
      this.$store.commit('setNav')
    },


    resetFilters () {
      let _this = this
      this.searchStringByName = ''
      this.searchStringByRunid = ''
      this.verortung = ''
      this.plansKeys = []
      this.hasplans = '2'
      this.hastags = '2'
      this.hasdescription = '2'
      this.hasmemos = '2'
      this.photodayKeys = []
      this.photodays.forEach(function (value, i) {
        if (value.value) { value.value = false }
      })
      // this.photodays = []
      // this.taggroups = []
      this.tagCreaterKeys = []
      this.selectedTags = []
      this.creator = []
      this.Creaters = []
      this.plansKeys = []
      this.tagselectionskeys = []
      this.selectionstags = []
      this.orderflag = ''
    },

    getSelectedTags () {
      let objs = {}
      let result = {}
      this.selectedTags.forEach((value, index) => {
        let obj = {
          [value]: 'AND'
        }
        result = Object.assign(objs, obj)
      })
      return result
    },

     getProject() {
      // console.log('CALL GET PROJECT')
       axios.post(process.env.VUE_APP_BASE_AMF_URL + `getProject&token=` + localStorage.sessiontoken, {
        "methodName": "getProject",
        "serviceName": "ProjectdocuService",
        "parameters": [
          this.$route.params.id
        ]
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
          if (response.status == 200) {
            // this.creators = response.data
            this.tags = response.data[0].params
            let tags = this.tagsRebuild(response.data[0].params)

            this.$store.state.photo.tags = this.tags
            this.$store.state.photo.taggroups = this.taggroups
          }
        })
        .catch(error => console.log(error))
        .finally(() => {

          $('.spinner-cover').hide()
        })
    },




     getUsers() {
      // console.log('CALL GET USERS')
       axios.post(process.env.VUE_APP_BASE_AMF_URL + `getUsers&token=` + localStorage.sessiontoken, {
        "methodName": "getUsersOfProject",
        "serviceName": "ProjectdocuService",
        "parameters": [
          this.$route.params.id
        ]
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      })
        .then(response => {
          if (response.status == 200) {

            this.$store.state.creators = response.data
            this.creators = response.data

          }
        }).catch(error => console.log(error))
        .finally(() => {
          $('.spinner-cover').hide()
        })
    },

    getPhotodays() {

      let _this = this
      // console.log('CALL GET PLANS')
        axios.post(process.env.VUE_APP_BASE_AMF_URL + `getPhotodays&token=` + localStorage.sessiontoken, {
          "methodName": "getPhotoCountsByDate",
          "serviceName": "ProjectdocuService",
          "parameters": [
            this.$route.params.id,
            null,
            [{
              "fieldname": "date-day",
              "_explicitType": "com\\projectdocu\\OrderSettingVO",
              "order": "DESC"
            }]
          ]
        }, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        })
        .then(response => {
          if (response.status == 200) {
            this.photodays = response.data.photos
            this.photodays.forEach(function(val, idx) {
              val.value = false


            })

            response.data.photos.forEach(function(val, idx) {
              response.data.photos[idx].formateddate = moment(String(val.date)).format('DD.MM.YYYY')
            })

            this.$store.state.photo.photodays = response.data.photos
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          $('.spinner-cover').hide()
        })

    },

     getPlans() {
      // console.log('CALL GET PLANS')
       axios.post(process.env.VUE_APP_BASE_AMF_URL + `getplans&token=` + localStorage.sessiontoken, {
        "methodName": "getPlansOfProject",
        "serviceName": "ProjectdocuService",
        "parameters": [
          this.$route.params.id,
          {
            'operands': [{
              "fieldname": "state",
              "fieldvalue": "0",
              "_explicitType": "com\\projectdocu\\PredicateOperandEQVO"
            }],
            "_explicitType": "com\\projectdocu\\PredicateOperatorAndVO"
          },
          [{
            "fieldname": "description",
            "order": "ASC",
            "_explicitType": "com\\projectdocu\\OrderSettingVO"
          }]
        ]
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      })
        .then(response => {

          if (response.status == 200) {
            this.plans = response.data.plans
            this.plans.forEach(function(val, idx) {
              val.value = false
            })
            this.$store.state.photo.plans = response.data.plans
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          $('.spinner-cover').hide()
        })
    },

     getFilters () {
      // console.log('CALL GET FILTERS')
       axios.post(process.env.VUE_APP_BASE_AMF_URL + `getfilters&token=` + localStorage.sessiontoken, {
          "methodName": "getPhotosOfProject",
          "serviceName": "ProjectdocuService",
          "parameters": [
            this.$route.params.id,
            0,
            0,
            null,
            []
          ]
        }, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        })
        .then(response => {
          if (response.status == 200) {
            // this.creators = response.data.data.creator
            // this.plans = response.data.data.plans
            // this.selections = response.data.data.selection

            // console.log('FETCHMETA', response.data.meta)

            // this.tags = response.data.data.tags
            // this.$store.state.photo.tags = this.tags
            this.$store.commit('setStartDates', this.formatDate(response.data.meta.minimumDate))
            this.$store.commit('setEndDates', this.formatDate(response.data.meta.maximumDate))
            // this.$store.state.meta.endDate = this.formatDate(response.data.meta.minimumDate)
            // this.$store.state.meta.startDate = this.formatDate(response.data.meta.maximumDate)
            if( this.$store.state.photo.endDate == '' || this.$store.state.photo.startDate == '') {
              this.$store.state.photo.endDate = this.formatDate(response.data.meta.minimumDate)
              this.$store.state.photo.startDate = this.formatDate(response.data.meta.maximumDate)
            }

            if(
              this.$store.state.photo.endDate != this.formatDate(response.data.meta.minimumDate) ||
              this.$store.state.photo.startDate != this.formatDate(response.data.meta.maximumDate)
            ) {
              this.$store.state.photo.endDate = this.formatDate(response.data.meta.minimumDate)
              this.$store.state.photo.startDate = this.formatDate(response.data.meta.maximumDate)
            }



            if(moment(response.data.meta.minimumDate).format('DD.MM.YYYY') == moment(response.data.meta.maximumDate).format('DD.MM.YYYY')) {

              this.$store.state.photo.meta.minimumdate = moment(response.data.meta.minimumDate).add(-2, 'days').format('YYYY-MM-DD')
              this.$store.state.photo.meta.maximumdate = moment(response.data.meta.maximumDate).add(2, 'days').format('YYYY-MM-DD')

            } else {

              this.$store.state.photo.meta.minimumdate = response.data.meta.minimumDate
              this.$store.state.photo.meta.maximumdate = response.data.meta.maximumDate

            }




            // console.log('getFilters StartDate', this.$store.state.photo.startDate)
          }
        }).catch(error => console.log(error))
        .finally(() => {
          $('.spinner-cover').hide()
        })
    },

    async getImages (caller = '') {

      $('.spinner-cover').show()
      let _this = this
      let selected_tags = _this.getSelectedTags()
      selected_tags.keys = this.tagselectionskeys

      this.callCounter++
      if(caller != 'pageChangeHandler') {
        this.$store.state.photo.page = 1
        this.$root.$emit('pageChangeHandler', 1)
      }
      // console.log('getImages Call ' + this.callCounter + ' Caller:' + caller)

      let itemsperpage = this.itemsperpage
      // let params = {
      //   'filterparams': {
      //     'searchstring': this.searchStringByName,
      //     'date_from': this.formatDateByYear(this.$store.state.meta.maximumDate),
      //     'date_to': this.formatDateByYear(this.$store.state.meta.minimumDate),
      //     'tags': this.tagselectionskeys,
      //     // "tags": this.testTag,
      //     'plan_ids': this.plansKeys,
      //     'selection_ids': this.selectionskeys,
      //     'creator_ids': this.tagCreaterKeys,
      //
      //     'hasplans': this.hasplans,
      //     'hastags': this.hastags,
      //     'hasdescription': this.hasdescription
      //   },
      //
      //   'order': {
      //     'tags': 'DESE'
      //   },
      //   'start': (this.$store.state.photo.page - 1),
      //   'perpage': 50
      // }

      // console.log('DATE on getIMages:', typeof (this.$store.state.photo.endDate))
      // console.log('DATE on getIMages:', this.$store.state.photo.endDate)


      var paramsOld = {
        "methodName": "getPhotosOfProject",
        "parameters": [
          this.$route.params.id,
          itemsperpage,
          (this.$store.state.photo.page - 1),
          this.getFilterBlock(),
          this.getOrderBlock()
        ],
        "serviceName": "ProjectdocuService"
      }



      // await axios.post(this.getImagesUrl, paramsOld, {
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `getImages&type=s&token=` + localStorage.sessiontoken, paramsOld, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      })
        .then(response => {
          if (response.status === 200) {
            let pho = []
            _this.photos = []
            this.meta = response.data.meta
            this.$store.state.meta = this.meta

            // console.log('WATCH - Reset enddate - A', this.$store.state.photo.endDate, this.$store.state.photo.startDate)
            if( this.$store.state.photo.endDate == '' || this.$store.state.photo.startDate == '' ||
                typeof this.$store.state.photo.endDate == 'object' || typeof this.$store.state.photo.startDate == 'object') {
              // console.log('WATCH - Reset enddate')
              this.$store.state.photo.endDate = this.formatDateBydot(this.meta.minimumDate)
              this.$store.state.photo.startDate = this.formatDateBydot(this.meta.maximumDate)
            }

            this.$store.state.photo.filtered = this.meta.maxcount //this.meta.filtered
            this.$store.state.photo.total = this.meta.maxcount
            this.$store.state.photo.length = response.data.photos.length
            if (!response.data.photos) {
              this.$store.state.photo.LStart = 0
              this.$store.state.photo.LEnd = 0
            }

            this.$store.state.photo.LStart = (this.meta.pagenumber * this.meta.pagesize) + 1
            this.$store.state.photo.LEnd = +(this.meta.pagenumber * this.meta.pagesize) + itemsperpage
            this.$store.state.photo.TPage = Math.ceil(this.meta.maxcount / this.meta.pagesize)
            if (!parseInt(this.meta.maxcount)) { this.$store.state.photo.TPage = 1 }
            this.$store.state.photo.page = parseInt(this.meta.pagenumber) + 1

            this.$store.state.photo.creator = ''



            if (response.data.photos) {
              pho = response.data.photos
              pho.forEach(function (value, i) {
              // response.data.photos.forEach(function (value, i) {
                // let ii = value
                let date = value.photodate
                // value.photodate = _this.formatDateBydot(date)
                value.photodate_c = date
                value.photodateBymonth = _this.formatDateByMonth(date)
                value.photodateBytime = _this.formatDateByTime(date)
                value.photodateBydot = _this.formatDateBydot(date)
                value.loaded = false
                // ii.userName = _this.getUserName(ii)
                value.src = require('@/assets/images/dumy.jpg')
                _this.getfileImage(value, i)
              })
            } else {
              pho = []
            }
            _this.photos = pho

          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.$root.$emit('afterImageLoad', _this.photos)
          this.$store.commit('setAllImages', _this.photos)
          this.$store.commit('setAllImagesForPhotoCanvas', _this.photos)

          $('.spinner-cover').hide()
        })
    },
// process.env.VUE_APP_BASE_URL + 'getfile/photo/' + photo.pdphotoid + '/450x450/4.5:4.5',
    getfileImage (photo, idx = false) {
      let _this = this
      const jwt = localStorage.getItem("jwt");
      fetch(
        process.env.VUE_APP_GET_METHOD_URL + "img&projectid=" + photo.projectid + "&id=" + photo.pdphotoid + `&token=` + localStorage.sessiontoken,
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            Authorization: `Bearer ${jwt}`
          }
        }
      ).then(response => response.blob())
        .then(response => {
          let reader = new FileReader()
          reader.readAsDataURL(response)
          reader.onload = function () {
            // console.log('Replace Photo', idx, _this.photos[idx])
            photo.src = reader.result
            photo.loaded = true
            if(idx !== false) {
              _this.photos[idx].src = reader.result
            }
          }
          // if(idx !== false) {
          //   this.photos[idx] = photo
          // }
          //  this.photos.push(photo)
          //  this.photos[idx] = (photo)

        })
    },


    formatDate (value) {
      if (value) {
        return moment(String(value)).format('DD.MM.YYYY')
      }
    },

    formatDateByDash (value) {
      if (value) {
        return moment(String(value)).format('DD-MM-YYYY')
      }
    },

    formatDateBydot (value) {
      if (value) {
        return moment(String(value)).format('DD.MM.YYYY')
      }
    },
    getUserName (id) {
      this.creators.forEach(function (value, i) {
        if (value.pduserid == id.user_id) {
          id.userName = value.firstname + ' ' + value.lastname
        }
      })
      return id.userName
    },

    formatDateByMonth (value) {
      if (value) {
        return moment(String(value)).format('MMM DD')
      }
    },
    formatDateByTime (value) {
      if (value) {
        return moment(String(value)).format('HH:mm')
      }
    },
    formatDateByYear (value) {
      let temp = ''
      // console.log('Before split', value)
      if (value != 'undefined' && value) {
        {
          let sp = value.split('.')
          return (sp[2] + '-' + sp[1] + '-' + sp[0])
        }
        if (temp == 'Invalid date') { return '' } else { return temp }
      }
    },
    tagsCheckbox: function (index, event) {
      let _this = this
      this.selectionstemp[index.id] = index
      this.selectionstemp[index.id].value = event.target.checked
      this.selectionskeys = []
      this.selectionstemp.forEach(function (value, i) {
        if (value.value) { _this.selectionskeys.push(parseInt(value.id)) }
      })
    },
    getTagSearchValue(tag) {
      let tagindex = this.selectionstags.findIndex((stag) => stag.projectparamid == tag.projectparamid)
      if(tagindex >= 0) {
        return this.selectionstags[tagindex].value
      }
      return '';
    },
    tagsCheckbox2: function (iindex, event) {
      // tagsCheckbox2(tag,$event)
      let temp = []
      let _this = this
      let index = JSON.parse(JSON.stringify(iindex))
      // TODO: FIX THIS SELECT WITH VALUE
      index.value = event.target.value
      index.checked = true
      //event.target.checked


      let tagindex = this.selectionstags.findIndex((tag) => tag.projectparamid == index.projectparamid)

      if(tagindex >= 0 && event.target.value == '') {
        // existiert, entfernen
        this.selectionstags.splice(tagindex, 1)
      } else {
        // existiert nicht, hinzufügen
        if(tagindex >= 0) { // existiert, anpassen
          // this.selectionstags[tagindex].value = event.target.value
          const updatedSelectionstags = [...this.selectionstags];
          updatedSelectionstags[tagindex].value = event.target.value;

          this.selectionstags = updatedSelectionstags;

          console.log('index CHANGE', iindex, event.target.value)
        } else { // Exitiert nicht - hinzufügen
          this.selectionstags.push(index)
          console.log('index PUSH', iindex, event.target.value)
        }
      }
    },
    tagsCheckbox3: function (index, event) {
      this.$store.state.photo.page = 1
      let _this = this
      this.Creaters[index.pduserid] = index
      this.Creaters[index.pduserid].value = event.target.checked
      this.tagCreaterKeys = []
      this.Creaters.forEach(function (value, i) {
        if (value.value) { _this.tagCreaterKeys.push(value.pduserid) }
      })
    },
    tagsCheckbox4: function (index, event, reset = false) {
      // console.log('tagsCheckbox4 Change', index, event, index.id)
      let _this = this

      if(reset) {
        this.plans.forEach(function (value, i) {
          // console.log('Planreset', value.pdplanid, i, value)
          if (value.value) {
            _this.plans[i].value = false
          }
        })
      }

      let planindex = this.plans.findIndex((plan) => plan.pdplanid == index.pdplanid)

      // console.log('Selected Plan', planindex)

      this.plans[planindex] = index
      this.plans[planindex].value = event.target.checked
      // this.plans[index.id] = index
      // this.plans[index.id].value = event.target.checked
      this.plansKeys = []
      this.plans.forEach(function (value, i) {
        if (value.value) { _this.plansKeys.push(value.pdplanid) }
      })
    },
    tagsCheckbox5: function (index, event, reset = false) {
      // console.log('tagsCheckbox4 Change', index, event, index.id)
      let _this = this

      if(reset) {
        this.photodays.forEach(function (value, i) {
          // console.log('Planreset', value.pdplanid, i, value)
          if (value.value) {
            _this.photodays[i].value = false
          }
        })
      }

      let photoindex = this.photodays.findIndex((photo) => photo.date == index.date)


      // this.photodays[photoindex] = index
      this.photodays[photoindex].value = event.target.checked


      this.photodayKeys = []
      this.photodays.forEach(function (value, i) {
        if (value.value) { _this.photodayKeys.push(value.date) }
      })


    },

    tagsRebuild: function(tags) {

      let rebuild = {}
      let last = ''
      let index = 0
      let groups = []

      // groupDefinition


      tags.forEach(function(value) {

        let ex = groups.filter((group) => group.group == value.group)
        // console.log('Existing', ex)
        if(!ex.length) {
          last = value.group
          index = 0
          groups.push({
            group: value.group,
            projectparamid: value.projectparamid
          })

          if(rebuild[value.group] == undefined) {
            rebuild[value.group] = {
              title: value.group,
              projectparamid: value.projectparamid,
              childs:[]
            }
          }
        }
      })

      console.log('tags', tags)
      tags.sort(function(a, b) {
        var keyA = a.order,
          keyB = b.order;
        // Compare the 2 dates
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });



      tags.forEach(function(value) {
        rebuild[value.group].childs.push(value)
      })


      // for( const[key, val] of Object.entries(rebuild)) {
      //   var srcchilds =  rebuild[key].childs
      //
      //   console.log('Groups Single', key, val)
      //   srcchilds.sort(function(a, b) {
      //     var keyA = a.order,
      //       keyB = b.order;
      //     // Compare the 2 dates
      //     if (keyA < keyB) return -1;
      //     if (keyA > keyB) return 1;
      //     return 0;
      //   });
      //
      //   rebuild[key].childs = srcchilds
      //   console.log('Groups Single', key, val, srcchilds)
      // }

      // rebuild.each(function(singlegroup, idx) {
      //   console.log('Groups Single', singlegroup, idx)
      //   // value.childs.sort(function(a, b) {
      //   //       var keyA = a.order,
      //   //         keyB = b.order;
      //   //       // Compare the 2 dates
      //   //       if (keyA < keyB) return -1;
      //   //       if (keyA > keyB) return 1;
      //   //       return 0;
      //   //     });
      // })


      this.taggroups = groups


      return rebuild


    },

    getFilterBlock: function() {

      console.log('')

      this.$store.dispatch('resetfilters', false)

      // console.log('STARTDATE', this.$store.state.photo.startDate)
      // console.log('ENDDATE', this.$store.state.photo.endDate)
      //
      // console.log('And Or Filter', this.selectedTags)

      let operands = []
      let _selectedTags = this.selectedTags


      // Filter for images by crdate

      console.log('PhotodayKeys', this.photodayKeys)
      if(this.photodayKeys.length) {
        this.$store.state.photo.activefilters.photodayKeys = true
        // console.log('Search Plans', this.plansKeys)

        let subops = []
        var i


        this.photodayKeys.forEach(function(val, idx) {
          // console.log(val, idx)
          subops.push({
            "fieldvalue": val,
            "fieldname": "photodate-day",
            "_explicitType": "com\\projectdocu\\PredicateOperandEQVO"
          })
        })


        console.log('PhotodayFilter', this.photodayKeys, subops)

        operands.push({
          "operands": subops,
          "_explicitType": "com\\projectdocu\\PredicateOperatorORVO"
        })

      } else {

        if(this.$store.state.photo.endDate && this.$store.state.photo.startDate && typeof(this.$store.state.photo.endDate) != 'object') {

          operands.push({
            "fieldname": "photodate-day",
            "fieldvalueFrom": this.formatDateByYear(this.$store.state.photo.endDate),
            "fieldvalueTo": this.formatDateByYear(this.$store.state.photo.startDate),
            "_explicitType": "com\\projectdocu\\PredicateOperandBetweenVO"
          })
        }

      }






      // Filter in Description or origname
      if(this.searchStringByName) {
        this.$store.state.photo.activefilters.searchStringByName = true
        // console.log('searchStringByName', this.searchStringByName)
        operands.push({
          'operands': [{
            "fieldname": "description",
            "fieldvalue": "%"+this.searchStringByName+"%",
            "_explicitType": "com\\projectdocu\\PredicateOperandLikeVO"
          }, {
            "fieldname": "origname",
            "fieldvalue": "%"+this.searchStringByName+"%",
            "_explicitType": "com\\projectdocu\\PredicateOperandLikeVO"
          }],
          '_explicitType': 'com\\projectdocu\\PredicateOperatorOrVO'
        })
      }

      // Filter by RunId
      if(this.searchStringByRunid) {
        this.$store.state.photo.activefilters.searchStringByRunid = true
        // console.log('searchStringByRunid', this.searchStringByRunid)
        operands.push({
          'operands': [{
            "fieldname": "runid",
            "fieldvalue": "%"+this.searchStringByRunid+"%",
            "_explicitType": "com\\projectdocu\\PredicateOperandLikeVO"
          }],
          '_explicitType': 'com\\projectdocu\\PredicateOperatorOrVO'
        })
      }

      // Filter if image is in Plan flaged
      if(this.hasplans && this.hasplans != '2') {
        this.$store.state.photo.activefilters.hasplans = true
        // console.log('HasPlans', this.hasplans)
        if(this.hasplans == '1') {
          operands.push({
            "fieldvalue": this.hasplans,
            "fieldname": "inplan",
            "_explicitType": "com\\projectdocu\\PredicateOperandEQVO"
          })
        } else {
          operands.push({
            "fieldvalue": '',
            "fieldname": "inplan",
            "_explicitType": "com\\projectdocu\\PredicateOperandEQVO"
          })
        }

      }

      if(this.hastags && this.hastags != '2') {
        // console.log('hastags', this.hastags)
        if(this.hastags == '1') {

          let subops = [];

          subops.push({
            "fieldvalue": '||',
            "fieldname": "params",
            "_explicitType": "com\\projectdocu\\PredicateOperandNEVO"
          })
          subops.push({
            "fieldvalue": '',
            "fieldname": "params",
            "_explicitType": "com\\projectdocu\\PredicateOperandNEVO"
          })

          operands.push({
            "operands": subops,
            "_explicitType": "com\\projectdocu\\PredicateOperatorAndVO"
          })

        } else {
          let subops = [];

          subops.push({
            "fieldvalue": '||',
            "fieldname": "params",
            "_explicitType": "com\\projectdocu\\PredicateOperandEQVO"
          })
          subops.push({
            "fieldvalue": '',
            "fieldname": "params",
            "_explicitType": "com\\projectdocu\\PredicateOperandEQVO"
          })

          operands.push({
            "operands": subops,
            "_explicitType": "com\\projectdocu\\PredicateOperatorOrVO"
          })

        }

      }

      // Filter for images in Plan
      if(this.plansKeys.length) {
        this.$store.state.photo.activefilters.plansKeys = true
        // console.log('Search Plans', this.plansKeys)

        let subops = [];
        var i

        this.plansKeys.forEach(function(val, idx) {
          // console.log(val, idx)
          subops.push({
            "fieldvalue": val,
            "fieldname": "pdplanid",
            "_explicitType": "com\\projectdocu\\PredicateOperandEQVO"
          })
        })

        // console.log(subops)
        // operands.push({
        //   "operands": subops,
        //   "_explicitType": "com\\projectdocu\\PredicateOperatorOrVO"
        // })

        if( _selectedTags.includes('plane') ) {
          operands.push({
            "operands": subops,
            "_explicitType": "com\\projectdocu\\PredicateOperatorOrVO"
          })
        } else {
          operands.push({
            "operands": subops,
            "_explicitType": "com\\projectdocu\\PredicateOperatorAndVO"
          })
        }

      }

      // Filter for Tags
      if(this.tagCreaterKeys.length) {
        this.$store.state.photo.activefilters.tagCreaterKeys = true
        // console.log('FILTER CREATOR', this.tagCreaterKeys)
        let subops = [];
        var i

        this.tagCreaterKeys.forEach(function(val, idx) {
          // console.log(val, idx)
          subops.push({
            "fieldvalue": val,
            "fieldname": "pduserid",
            "_explicitType": "com\\projectdocu\\PredicateOperandEQVO"
          })
        })


        // console.log(subops)

        operands.push({
          "operands": subops,
          "_explicitType": "com\\projectdocu\\PredicateOperatorOrVO"
        })
      }


      if(this.hasdescription && this.hasdescription != '2') {
        this.$store.state.photo.activefilters.hasdescription = true
        // console.log('FILTER hasdescription', this.hasdescription)
        if(this.hasdescription == '1') {
          operands.push({
            "fieldvalue": "",
            "fieldname": "description",
            "_explicitType": "com\\projectdocu\\PredicateOperandNEVO"
          })
        } else {
          operands.push({
            "fieldvalue": "",
            "fieldname": "description",
            "_explicitType": "com\\projectdocu\\PredicateOperandEQVO"
          })
        }
      }


      if(this.$store.state.photo.rectangleprops != undefined &&
        this.$store.state.photo.rectangleprops != {} &&
        this.$store.state.photo.rectangleprops != null &&
        this.$store.state.photo.rectangleprops.x_tl != undefined &&
        this.$store.state.photo.rectangleActive
      ) {

        this.$store.state.photo.activefilters.rectangle = true

        console.log('this.$store.state.photo.activefilters.rectangle', this.$store.state.photo.rectangleprops);

        let rectvars = this.$store.state.photo.rectangleprops;

        let tl_subops = [];
        let br_subops = [];
        let subops = [];
        var i

        tl_subops.push({
          "fieldvalue": rectvars.y_tl,
          "fieldname": "ycoord",
          "_explicitType": "com\\projectdocu\\PredicateOperandGEVO"
        })
        tl_subops.push({
          "fieldvalue": rectvars.x_tl,
          "fieldname": "xcoord",
          "_explicitType": "com\\projectdocu\\PredicateOperandGEVO"
        })
        br_subops.push({
          "fieldvalue": rectvars.y_br,
          "fieldname": "ycoord",
          "_explicitType": "com\\projectdocu\\PredicateOperandLEVO"
        })
        br_subops.push({
          "fieldvalue": rectvars.x_br,
          "fieldname": "xcoord",
          "_explicitType": "com\\projectdocu\\PredicateOperandLEVO"
        })

        operands.push({
          "operands": tl_subops,
          "_explicitType": "com\\projectdocu\\PredicateOperatorAndVO"
        })

        operands.push({
          "operands": br_subops,
          "_explicitType": "com\\projectdocu\\PredicateOperatorAndVO"
        })



        console.log('START FILTER WITH RECTANGE', operands);


      }


      if(this.hasmemos && this.hasmemos != '2') {
        this.$store.state.photo.activefilters.hasmemos = true
        // console.log('FILTER hasmemos', this.hasmemos)
        if(this.hasmemos == '1') {
          operands.push({
            "fieldvalue": "1",
            "fieldname": "memos",
            "_explicitType": "com\\projectdocu\\PredicateOperandEQVO"
          })
        } else {
          operands.push({
            "fieldvalue": "0",
            "fieldname": "memos",
            "_explicitType": "com\\projectdocu\\PredicateOperandEQVO"
          })
        }
      }


      // if(this.tagselectionskeys.length) {
      if(this.selectionstags.length) {
        // this.$store.state.photo.activefilters.tagselectionskeys = true
        this.$store.state.photo.activefilters.selectionstags = true
        console.log('FILTER tagselectionskeys', this.tagselectionskeys)
        // console.log('FILTER TAGS', this.tagselectionskeys)
        // console.log('SelectionSet', this.selectedTags)
        // console.log('TagsSelectionKeys', this.tagselectionskeys)
        // console.log('SelectionTags', this.selectionstags)

        // Step 1 - Reorder to group
        // Step 2 - Check if AND or OR
        let groups = []
        let _tagselectionkeys = this.selectionstags
        // let _tagselectionkeys = this.tagselectionskeys

        // Build Tag Groups
        _tagselectionkeys.forEach(function(val, idx) {

          if(groups.includes(val.group)) {
          } else {
            groups.push(val.group)
          }

        })


        groups.forEach(function(groupval) {


          let subops = [];
          var i

          _tagselectionkeys.forEach(function(val, idx) {
            if(val.group == groupval) {
              // console.log(val, idx)

              if(val.type == '1') {
                // is text
                subops.push({
                  "fieldvalue": '*|' + val.projectparamid + '=*' + val.value + '*|*',
                  "fieldname": "params",
                  "_explicitType": "com\\projectdocu\\PredicateOperandLikeVO"
                })
              } else {
                subops.push({
                  "fieldvalue": '*|' + val.projectparamid + '=1|*',
                  "fieldname": "params",
                  "_explicitType": "com\\projectdocu\\PredicateOperandLikeVO"
                })
              }
            }
          })

          // console.log(subops)

          if( _selectedTags.includes(groupval) ) {
            operands.push({
              "operands": subops,
              "_explicitType": "com\\projectdocu\\PredicateOperatorOrVO"
            })
          } else {

            operands.push({
              "operands": subops,
              "_explicitType": "com\\projectdocu\\PredicateOperatorAndVO"
            })
          }
        })
      }
      this.$store.dispatch('filtersActive')
      let filterBlock = {
        "operands": operands,
        "_explicitType": "com\\projectdocu\\PredicateOperatorAndVO"
      }
      this.$store.state.photo.currentPhotoFilter = filterBlock

      return filterBlock

      // let params = {
      //   'filterparams': {
      //     'searchstring': this.searchStringByName,
      //     'date_from': this.formatDateByYear(this.$store.state.meta.maximumDate),
      //     'date_to': this.formatDateByYear(this.$store.state.meta.minimumDate),
      //     'tags': this.tagselectionskeys,
      //     // "tags": this.testTag,
      //     'plan_ids': this.plansKeys,
      //     'selection_ids': this.selectionskeys,
      //     'creator_ids': this.tagCreaterKeys,
      //
      //     'hasplans': this.hasplans,
      //     'hastags': this.hastags,
      //     'hasdescription': this.hasdescription
      //   },
      //
      //   'order': {
      //     'tags': 'DESE'
      //   },
      //   'start': (this.$store.state.photo.page - 1),
      //   'perpage': 50
      // }


      // return {
      //   "operands":[
      //     {
      //       "fieldname": "photodate-day",
      //       "fieldvalueFrom": "2010-03-26",
      //       "fieldvalueTo": "2019-05-13",
      //       "_explicitType": "com\\projectdocu\\PredicateOperandBetweenVO"
      //     }
      //   ],
      //   "_explicitType": "com\\projectdocu\\PredicateOperatorAndVO"
      // };
      // 'searchstring': this.searchStringByName,
      //   'date_from': this.formatDateByYear(this.$store.state.photo.endDate),
      //   'date_to': this.formatDateByYear(this.$store.state.photo.startDate),
      //   'tags': this.tagselectionskeys,
      //   // "tags": this.testTag,
      //   'plan_ids': this.plansKeys,
      //   'selection_ids': this.selectionskeys,
      //   'creator_ids': this.tagCreaterKeys,
      //
      //   'hasplans': this.hasplans,
      //   'hastags': this.hastags,
      //   'hasdescription': this.hasdescription




    },
    getOrderBlock: function() {

      let field = 'photodate'
      let dir = 'DESC'

      if(this.orderflag) {
        // console.log('Order Direction', this.orderflag)
        let ordersplits = this.orderflag.split(/[ ]+/)
        field = ordersplits[0]
        dir = ordersplits[1]
      }


      let orderBlock = [{
        "_explicitType": "com\\projectdocu\\OrderSettingVO",
        "fieldname": field,
        "order": dir.toUpperCase()
      }]

      this.$store.state.photo.currentPhotoOrder = orderBlock

      return orderBlock
    },
    filterchange: function() {
      this.$store.state.photo.page = 1
      this.$root.$emit('pageChangeHandler', 1)
    }



  },

  watch: {
    searchStringByName: function (value) {
      if (value.length > 1 || value.length === 0) {
        this.getImages('searchStringByName')
      }
      this.$parent.searchString = value
    },
    photosUpdate: function () {
      console.log("here we got the event again.....")
      this.getFilters();
      this.getImages('Refresh')
    },
    searchStringByRunid: function (value) {
      if (value.length > 1 || value.length === 0) {
        this.getImages('searchStringByRunid')
      }
      this.$parent.searchString = value
    },

    '$store.state.photo.canvasplan': function() {
      let _this = this
      _this.tagsCheckbox4(this.$store.state.photo.canvasplan, {target: {checked:true}}, true)
      _this.getImages('store.state.photo.canvasplan')
      // this.$confirm({
      //   title: 'Soll der Filter für den gewählten Plan aktiviert werden?',
      //   message: 'Es werden nur die Bilder, welche in diesem Plan verortet sind angezeigt.',
      //   button: {
      //     no: 'Nein',
      //     yes: 'Ja'
      //   },
      //   callback: confirm => {
      //     console.log('Confirm', confirm)
      //     if(confirm) {
      //
      //     }
      //   }
      // })
    },
    '$store.state.photo.removePlanFilter': function() {
      let _this = this
      if(!_this.$store.state.photo.removePlanFilter) {
        return
      }

      this.$confirm({
        title: 'Plan-Filter deaktivieren?',
        message: 'Soll der aktuelle Plan-Filter deaktiviert werden, sodass auf der linken Seite alle Projektfotos angezeigt werden?\n',
        button: {
          no: 'Nein',
          yes: 'Ja'
        },
        callback: confirm => {
          console.log('Confirm', confirm)
          if(confirm) {
            _this.tagsCheckbox4(this.$store.state.photo.canvasplan, {target: {checked:false}}, true)
            _this.$store.state.photo.removePlanFilter = false
          }
        }
      })
    },
    '$store.state.photo.restorePlanFilter': function() {
      let _this = this
      console.log('PhotoStore', _this.$store.state.photo)
      if(!_this.$store.state.photo.restorePlanFilter) {
        return
      }



      // this.$confirm({
      //   title: 'Plan-Filter wiederherstellen?',
      //   message: 'Soll der vorherige Plan-Filter wiederaktiviert werden, sodass auf der linken Seite nur Projektfotos vom aktuellen Plan angezeigt werden?\n',
      //   button: {
      //     no: 'Nein',
      //     yes: 'Ja'
      //   },
      //   callback: confirm => {
      //     console.log('Confirm', confirm)
      //     if(confirm) {
      //
      //     }
      //   }
      // })
      _this.tagsCheckbox4(this.$store.state.photo.canvasplan, {target: {checked:true}})
      _this.$store.state.photo.restorePlanFilter = false

    },

    refresh_photos_list: function() {
      this.getFilters();
      this.getImages('Refresh')
    },

    plansKeys: function () {
      this.getImages('plansKeys')
    },
    photodayKeys: function () {
      this.getImages('photodayKeys')
    },
    tagselectionskeys: function () {
      this.getImages('tagselectionskeys')
    },
    selectionstags: function () {
      this.getImages('selectionstags')
    },
    selectionskeys: function () {
      this.getImages('selectionskeys')
    },
    tagCreaterKeys: function () {
      this.getImages('tagCreaterKeys')
    },
    hasdescription: function () {
      this.getImages('hasdescription')
    },
    hasmemos: function () {
      this.getImages('hasmemos')
    },
    hasplans: function () {
      this.getImages('hasplans')
    },
    hastags: function () {
      this.getImages('hastags')
    },
    selectedTags: function () {
      this.getImages('selectedTags')
    },
    orderflag: function () {
      this.getImages('orderflag')
    },
    '$store.state.photo.rectangleprops': {
      handler() {

        if(this.$store.state.photo.rectangleprops != undefined &&
          this.$store.state.photo.rectangleprops != {}) {
          console.log('Rectangle Filter Watchcall', this.$store.state.photo.rectangleprops)

          this.getImages('rectangle');
        }
      },
      deep: true // Überwacht auch verschachtelte Änderungen
    }

  }
}

</script>



// WEBPACK FOOTER //
// src/components/photo/components/SideNav.vue